<template>
  <!--
      作者：gmshop
      时间：2020-06-01
      描述：插件中心-卡券-编辑
  
    -->
  <div class="product-add pb50" v-loading="loading">
    <!--编辑卡券-->
     <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
       <div class="common-form">编辑卡券</div>
      <el-form-item label="名称" prop="name"><el-input v-model="form.name" placeholder="请输入名称" class="max-w460"></el-input></el-form-item>
       <el-form-item label="卡券类型" prop="card_type">
        <el-radio-group v-model="form.card_type">
          <el-radio :label="10">直冲类</el-radio>
          <el-radio :label="20">卡密类</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="产品编码" prop="product_code"><el-input v-model="form.product_code" placeholder="请输入产品编码" class="max-w460"></el-input></el-form-item>
      <el-form-item label="账号输入提示" prop="account_tips">
        <el-input v-model="form.account_tips" placeholder="请输入账号提示" class="max-w460"></el-input>
        <div class="help">用于用户端兑换输入账号的提示，举例：请填写淘宝账号</div>
      </el-form-item>
      <el-form-item label="缩略图" prop="image_id">
        <div>
          <el-button type="primary" @click="openUpload">上传图片</el-button>
          <img class="mt10" :src="image.file_path"  width="120px;" alt="" />
          <!--上传图片组件-->
          <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
        </div>
      </el-form-item>
      <el-form-item label="使用说明">
        <div class="edit_container">
          <Uediter v-if="!loading" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
     </el-form>
  </div>
</template>

<script>
import GcardApi from '@/api/gcard.js';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*编辑器*/
    Uediter,
    /*图片上传*/
    Upload
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*是否上传图片*/
      isupload: false,
      open_store:false,
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        id: '',
        name: '',
        image_id: '',
        card_type: 0,
        product_code: '',
        content: '',
      },
      image :{},
      /*新闻类别*/
      category: [],
      excludeIds:[],
      stores:[],
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        card_type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        product_code: [{ required: true, message: '请输入产品码', trigger: 'blur' }],
        image_id: [{ required: true, message: '请选择图片', trigger: 'blur' }],
      }
    };
  },
  created() {

    this.getDetail();

  },

  methods: {

    /*上传*/
    openUpload() {
      this.isupload = true;
    },

    getContent: function() {
      return this.$refs.ue.getUEContent();
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.image.file_path = e[0].file_path;
      }
      this.isupload = false;
    },

    getDetail() {
      let self = this;
      // 取到路由带过来的参数
      const params = self.$route.query.id;
      GcardApi.getEdit({id: params},true).then(res => {
          self.ueditor.text = res.data.model.content;
          self.form = res.data.model;
          if(!self.image){
            self.image={};
          }
          self.image = self.form.image
          self.loading = false;
        })
        .catch(error => {});
    },

    /*修改卡券*/
    onSubmit() {
      let self = this;
      self.form.content = this.$refs.ue.getUEContent();
      self.form.store_ids = self.excludeIds;
      let params = this.form;
      // 取到路由带过来的参数
      GcardApi.edit(params, true)
        .then(data => {
          self.$message({
            message: data.msg,
            type: 'success'
          });
          self.$router.push('/gcard/gcard/index');
        })
        .catch(error => {});
    },

    /*取消添加，返回卡券列表*/
    cancelFunc() {
      this.$router.push({
        path: '/gcard/gcard/index'
      });
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .item {
  position: relative;
  width: 110px;
  height: 130px;
  margin-top: 10px;
  margin-right: 10px;
  overflow: hidden;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}
.draggable-list .item .img {
  width: 110px;
  height: 110px;
}
.store-name {
  height:20px;
  line-height:20px;
  background-color: #aaa;
  position: relative;
  top: -20px;
  opacity: 0.9;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/gcard/gcard/edit.vue